import { render, staticRenderFns } from "./Kview.vue?vue&type=template&id=9bf05ad4"
import script from "./Kview.vue?vue&type=script&lang=js"
export * from "./Kview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports